import { accessRequestPermissions } from '@infuse/api/iam/access-request';
import {
  tenantOrganisationPermissions,
  tenantPermissionPermissions,
  tenantPermissions,
  tenantRolePermissions,
  tenantUserPermissions
} from '@infuse/api/iam/tenant';
import {
  AccessRequestDetailSlideIn,
  AccessRequestOverviewTab,
  TenantAccessRequestsTab
} from '@infuse/iam/access-request/pages';
import { RoleDetailSlideIn, RolePermissionsTab, RolesPage } from '@infuse/iam/role/pages';
import {
  TenantOrganisationTab,
  TenantPage,
  TenantPermissionTab,
  TenantRoleTab,
  TenantsPage,
  TenantUsersTab
} from '@infuse/iam/tenant/pages';

import { InfusePageView } from '@infuse/ui/layouts';
import { AppRouter } from '@infuse/ui/router';
import { Plugin } from 'vue';

export const TenantFeaturePlugin: Plugin = {
  install() {
    AppRouter.addRoute('main', {
      path: '/tenant',
      component: InfusePageView,
      meta: {
        name: 'iam.tenants.nav.tenants',
        icon: 'cubes',
        group: 'nav.nav-group.iam',
        breadcrumb: 'iam.tenants.nav.tenants',
        permissionIds: [tenantPermissions.SEARCH]
      },
      children: [
        {
          path: '',
          name: 'tenant',
          component: TenantsPage
        },
        {
          path: ':id',
          components: {
            default: TenantPage
          },
          meta: {
            permissionIds: [tenantPermissions.GET]
          },
          children: [
            {
              path: '',
              name: 'tenant.details',
              redirect: {
                name: 'tenant.organisations'
              }
            },
            {
              path: 'details',
              name: 'tenant.organisations',
              component: TenantOrganisationTab,
              meta: {
                type: 'tab',
                label: 'iam.tenants.nav.organisations',
                breadcrumb: 'iam.tenants.nav.details',
                permissionIds: [tenantOrganisationPermissions.SEARCH]
              }
            },
            {
              path: 'users',
              name: 'tenant.users',
              component: TenantUsersTab,
              meta: {
                type: 'tab',
                label: 'iam.tenants.nav.users',
                breadcrumb: 'iam.tenants.nav.details',
                permissionIds: [tenantUserPermissions.SEARCH]
              }
            },
            {
              path: 'permissions',
              name: 'tenant.permissions',
              component: TenantPermissionTab,
              meta: {
                type: 'tab',
                label: 'iam.tenants.nav.permissions',
                breadcrumb: 'iam.tenants.nav.details',
                permissionIds: [tenantPermissionPermissions.SEARCH]
              }
            },
            {
              path: 'roles',
              name: 'tenant.roles',
              component: TenantRoleTab,
              meta: {
                type: 'tab',
                label: 'iam.tenants.nav.roles',
                breadcrumb: 'iam.tenants.nav.details',
                permissionIds: [tenantRolePermissions.SEARCH]
              }
            },
            {
              path: 'access-requests',
              name: 'tenant.access-requests',
              component: TenantAccessRequestsTab,
              meta: {
                type: 'tab',
                label: 'iam.tenants.nav.access-requests',
                breadcrumb: 'iam.tenants.nav.details',
                permissionIds: [accessRequestPermissions.SEARCH]
              }
            },
            {
              path: 'access-requests/:accessRequestId',
              components: {
                default: TenantAccessRequestsTab,
                slideIn: AccessRequestDetailSlideIn
              },
              meta: {
                slideInParent: 'tenant.access-requests',
                permissionIds: [accessRequestPermissions.SEARCH]
              },
              children: [
                {
                  path: '',
                  redirect: { name: 'tenant.access-requests.details' }
                },
                {
                  path: 'overview',
                  name: 'tenant.access-requests.details',
                  component: AccessRequestOverviewTab,
                  meta: {
                    type: 'tab',
                    label: 'iam.access-requests.tabs.overview',
                    permissionIds: [accessRequestPermissions.GET],
                    disablePermissionRouteGuard: true
                  }
                }
              ]
            }
          ]
        },
        {
          path: ':id/roles/:roleId',
          components: {
            default: RolesPage,
            slideIn: RoleDetailSlideIn
          },
          children: [
            {
              path: '',
              redirect: {
                name: 'tenant.role.permissions'
              }
            },
            {
              path: 'permissions',
              name: 'tenant.role.permissions',
              component: RolePermissionsTab,
              meta: {
                type: 'tab',
                label: 'tabs.common.permissions',
                permissionIds: [tenantRolePermissions.SEARCH_PERMISSIONS, tenantPermissionPermissions.SEARCH],
                disablePermissionRouteGuard: true
              }
            }
          ]
        }
      ]
    });
  }
};
